import { msg } from '@lingui/core/macro';
import type { FieldMetadataMessageDescriptorDef } from './types';

export const vehicleTypeField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Vehicle type',
    context: 'The type of vehicle.',
  }),
};

export const vehicleCategoryField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Vehicle category',
    context: 'The category of the vehicle.',
  }),
  externalDescription: msg({
    message: 'The category of the vehicle',
    context: 'Vehicle category description',
  }),
};

export const vehiclePowertrainTypeField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Vehicle powertrain type',
    context: 'The powertrain type of the vehicle.',
  }),
  externalDescription: msg({
    message: 'The powertrain type of the vehicle',
    context: 'Vehicle powertrain type description',
  }),
};

export const vehicleQuantityField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Vehicle quantity',
    context: 'The number of vehicles sold.',
  }),
  externalDescription: msg({
    message: 'The number of vehicles sold.',
    context: 'Vehicle quantity',
  }),
};

export const transportationModeField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Transportation mode',
    context: 'The mode of transportation used.',
  }),
  externalDescription: msg({
    message: 'The mode of transportation used.',
    context: 'Transportation mode',
  }),
};

export const tripKindField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Trip kind',
    context: 'The kind of trip taken (eg. round-trip or one-way).',
  }),
};

export const flightRouteField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Flight route',
    context: 'An IATA airport code.',
  }),
  externalDescription: msg({
    message: 'A list of IATA airport codes.',
    context: 'Flight route',
  }),
};

export const passengerQuantityField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Passenger quantity',
    context: 'The number of passengers.',
  }),
  externalDescription: msg({
    message: 'The number of passengers.',
    context: 'Passenger quantity',
  }),
};

export const distanceQuantityField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Distance',
    context: 'The distance traveled.',
  }),
  externalDescription: msg({
    message: 'The distance traveled.',
    context: 'Distance',
  }),
};

export const distanceUnitField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Distance unit',
    context:
      'Unit (e.g. km, miles) of a column of data describing the distance traveled',
  }),
  externalDescription: msg({
    message: 'The unit of distance traveled.',
    context: 'Distance unit',
  }),
};

export const isCompanyOwnedOrLeasedField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Asset is owned or leased by the company',
    context: 'Whether the company owns or leases the asset.',
  }),
};

export const electricityEfficiencyField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Electricity efficiency',
    context: 'The electricity efficiency of the vehicle',
  }),
  externalDescription: msg({
    message: 'The electricity efficiency of the vehicle',
    context: 'Electricity efficiency description',
  }),
};

export const fuelEfficiencyField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Fuel efficiency',
    context: 'The fuel efficiency of the vehicle',
  }),
  externalDescription: msg({
    message: 'The fuel efficiency of the vehicle',
    context: 'Fuel efficiency description',
  }),
};
